<template>
  <div id="bg" class="bg">
    <div class="logoBox">账户登录{{ fromRouter }}</div>
    <div class="loginWrap">
      <div class="w1200">
        <div class="login" @keyup.13="doLogin">
          <template>
            <div class="clearfix" style="text-align: left;">
              <el-radio v-model="radio" label="1" style="margin-right:60px;">普通登录</el-radio>
              <el-radio v-model="radio" label="2">快速登录</el-radio>
            </div>
          </template>
          <div class="form-horizontal pr"  v-if="radio === '1'">
              <div class="form-group input-group input-group-lg ">
                <div class="clearfix" style="margin-top: 40px;margin-bottom: 13px;"><span class="fl">账号</span><span class="fr" @click="gotoRegister()" style="cursor: pointer;color: red">免费注册</span></div>
                <span class="input-group-addon"><i class="fa fa-user-o" aria-hidden="true"></i></span>
                <input type="text" class=" form-control userform" placeholder="邮箱或者手机号" v-model="userInfo.account">
              </div>
              <div class="form-group input-group input-group-lg">
                <div style="margin-top:17px;margin-bottom:13px;text-align:left;">密码</div>
                <span class="input-group-addon"><i class="fa fa-key" aria-hidden="true"></i></span>
                <input type="password" class=" form-control pwdform" placeholder="请输入密码" v-model="userInfo.password">
              </div>
              <div class="form-group input-group input-group-lg"  v-if="verificationCodeAShow">
                <div class="clearfix" style="margin-top: 17px;margin-bottom: 13px;"><span class="fl">验证码</span></div>
                    <div style="display:flex;">
                      <input v-model="userInfo.pngCode" style="width: 220px; text-indent: 1em;" />
                      <img :src="numAImg_src" class="verificationIMG messageImg" alt="点击刷新图片" @click="reflashNumA"/>
                    </div>
              </div>
              <div class="clearfix" style="margin: 15px 0 25px"><el-checkbox v-model="isCookies" class="fl">30天免登录</el-checkbox><div class="fr forget" style="cursor:pointer;" @click="gotoFindPWD()">忘记密码?</div></div>
               <div class="msg tc colorRed" v-if="this.verfiy === false">验证失败</div>
              <div class="form-group tc">
                <el-button class="form-control loginIn" style="margin-top: -8px;" @click="doLogin">登 录</el-button>
              </div>
            </div>
            <div class="messageLogin form-horizontal" v-else>
              <div class="form-group input-group input-group-lg ">
                <div class="clearfix" style="margin-top: 40px;margin-bottom: 13px;"><span class="fl">账号</span><span class="fr" @click="gotoRegister()" style="cursor: pointer;color: red">免费注册</span></div>
                <span class="input-group-addon"><i class="fa fa-user-o" aria-hidden="true"></i></span>
                    <input type="text" class=" form-control userform" placeholder="输入手机号" v-model="messageInfo.account">
              </div>
              <div class="form-group input-group input-group-lg"  v-if="verificationCodeShow">
                <div class="clearfix" style="margin-top: 40px;margin-bottom: 13px;"><span class="fl">验证码</span></div>
                    <input v-model="messageInfo.numVerificationCode" style="width: 220px; text-indent: 1em;" />
                    <el-button type="primary" class="fr sendVerification" style="width:103px;margin-left:15px;padding:16px 0px;border-radius:2px;" @click="getVerificationCode" v-text="'发送验证码'"></el-button>
                    <img :src="numImg_src" class="verificationIMG" style="margin-top:15px;" alt="点击刷新图片" @click="reflashNum"/>
              </div>
              <div class="form-group input-group input-group-lg" v-else>
                <div style="margin-top:17px;margin-bottom:13px;text-align:left;">验证码</div>
                <span class="input-group-addon"><i class="fa fa-key" aria-hidden="true"></i></span>
                <div class="clearfix">
                  <input class=" form-control pwdform fl" style="width:100%;margin-bottom:50px;" placeholder="请输入验证码" v-model="messageInfo.smsCode">
                </div>
              </div>
              <el-button class="form-control loginIn" @click="dosmsLogin" style="margin-top: 20px;margin-left:15px;">登 录</el-button>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
// import slideVerfiy from '@/components/slideVerfiy/slideVerfiy';
import { LoginService } from '../../service/login.service'
import Axios from 'axios'

export default {
  name: 'login',
  // components: {
  //   slideVerfiy
  // },
  data () {
    return {
      userInfo: {
          account : '',
          password : '',
          pngCode: ''
      },
      numAImg_src: '',//密码登录验证码
      verfiyShow: false,
      verfiy :true,
      isCookies: false,
      type: 'jpg',
      radio: '1',
      messageInfo: {
        account: '',
        smsCode: '',
        numVerificationCode:''
      },
      verificationCodeAShow: true,//密码登录验证码显示状态
      verificationCodeShow: true,//短信登录验证码显示状态
      fromRouter: this.$route.query.redirect,
      numImg_src: '',//短信登录验证码
      timerData: 60
    }
  },
  watch: {
    timerData(newV) {
        return newV
    }
  },
  // computed:{
  //   img_src() {
  //     return '/mock/images/verification/' + '' +  this.random(1,14) + '.' + this.type
  //   }
  // },
  methods : {
    async doLogin() {
      if(this.radio === '1'){
        if (this.userInfo.account == ''){
            this.$notify({
                title : '提示信息',
                message : '用户名不能为空',
                type : 'error'
            });
            return false
        }
        if (this.userInfo.password == ''){
            this.$notify({
                title : '提示信息',
                message : '密码不能为空',
                type : 'error'
            });
            return false
        }
        try{
          const data = await LoginService.login(this.userInfo)
          localStorage.setItem('token',data.token)
          localStorage.setItem('username',data.username)
          this.$store.commit('SET_NAME',data.username)
          this.$forceUpdate();
          this.$router.replace('/')
          
        }catch(e) {
          this.reflashNumA();

        }
        //this.verfiyShow = true
      }else{
        console.log('短信登录')
        this.$router.push('/')
      }
        
    },
    random(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    },
    gotoRegister() {
      this.$router.push({path:'/register',query:{model:'userRegister'}})
    },
    gotoFindPWD() {
      this.$router.push('/forgetPasswordNew');
    },
    reflashNumA() {
      var url = 'https://api.goodyiyao.cn/web/other/digitalVerificationCode?model=login'
      let that = this
      Axios.get(url,{ responseType: 'arraybuffer',withCredentials: true}).then(function(res){
        let codeImg =  'data:image/png;base64,' + btoa(
        new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
        that.numAImg_src = codeImg
      })
    },
    reflashNum() {
      var url = 'https://api.goodyiyao.cn/web/other/digitalVerificationCode?model=smsLogin'
      let that = this
      Axios.get(url,{ responseType: 'arraybuffer',withCredentials: true}).then(function(res){
        let codeImg =  'data:image/png;base64,' + btoa(
        new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
        that.numImg_src = codeImg
      })
    },
    async getVerificationCodeA() {
      try {
        await LoginService.smsCodeSend(this.userInfo.account,'login',this.userInfo.numVerificationCode)
        this.verificationCodeAShow = false
      }catch(e) {
        console.log(e)
      }
    },
    async getVerificationCode() {
      try {
        await LoginService.setCheckNumber({
          type:'mobile',
          account:this.messageInfo.account,
          model:'smsLogin',
          code_num:this.messageInfo.numVerificationCode
        }).then(()=>{
          this.verificationCodeShow = false
        })
      }catch(e) {
        console.log(e)
      }
    },
    async dosmsLogin() {
      const data = await LoginService.smsLogin(this.messageInfo)
      localStorage.setItem('token',data.token)
      localStorage.setItem('username',data.username)
      this.$store.commit('SET_NAME',data.username)
      this.$router.push('/')
    },
    async onSuccess(){
      try{
        const data = await LoginService.login(this.userInfo)
        localStorage.setItem('token',data.token)
        localStorage.setItem('username',data.username)
        this.$store.commit('SET_NAME',data.username)
        this.$router.push('/')
      }catch(e){
        this.verfiyShow = false
        this.$refs.slideVerify.refresh()
      }
    },
    onFail(){
      this.type = 'png',
      this.type = 'jpg'
      this.verfiy = false
      setTimeout(() => {
        this.verfiy = true
      }, 400);
      return false
    },
    onRefresh(){
      this.type = 'png',
      this.type = 'jpg'
    }
  },
  created() {
    this.reflashNum()
    this.reflashNumA()
  }
} 
</script>

<style scoped>
  .logoBox{
    width: 1200px;
    height: 164px;
    line-height: 164px;
    font-size: 38px;
    text-indent: 285px;
    text-align: left;
    color: #727272;
    background: url('../../assets/images/views/logo.png') left center no-repeat;
    margin: 0 auto;
  } 
  .loginWrap {
    height: 800px;
    background:url('https://api.goodyiyao.cn/static/upload/other/login.jpg') center center no-repeat;
    background-size: 100%;
  }
  .w1200{
    margin: 0 auto;
    position: relative;
    height: 100%;
  }
  .login{
    width: 340px;
    position: absolute;
    right: 0;
    background: #fff;
    top: 50%;
    margin-top: -230px;
    padding: 30px 75px 25px;
  }
  .login-btn {
    background-color: whitesmoke;
  }
  .logo {
    font-family: "DejaVu Sans Mono";
    color: lightblue;
    font-size: 50px;
  }
  .form-horizontal input{
    width: 100%;
    height: 48px;
    line-height: 48px;
    border: 1px solid #dbdee0;
    border-radius: 3px;
    text-indent: 3.5em;
  }
  .userform{
    background: url('../../assets/images/icon/personIcon.png') 12px center no-repeat;
  }
  .pwdform{
    background: url('../../assets/images/icon/lockIcon.png') 12px center no-repeat;
  }
  .loginIn{
    width: 310px;
    height: 51px;
    background: #2e98d6;
    border-color: #2e98d6;
    margin-top: 25px;
    color: #fff;
  }
  .messageLogin .pwdform{
    width: 225px;
  }
  .messageImg{
    width: 160px;
    height: 50px;
    line-height: 50px;
    margin-left: 8px;
  }
  #slideVerify{
    left: 50%;
    margin-left: -155px;
    margin-top: 20px;
  }
  .verfiy{
    width: 310px;
    height: 230px;
    margin-left: -155px;
    margin-top: -165px;
    left: 50%;
    top: 50%;
    padding: 8px;
    border: 1px solid #e3e2e1;
    box-shadow: 0 0 3px #6f6f6f;
    background: #fff;
    z-index: 5;
    
  }
  .forget:hover{
    color: #2E98D5;
  }
  .msg{
    position: absolute;
    left: 50%;
    transform: translateX(-50%)
  }
</style>

<style>
  .login .el-radio__inner,.login .el-radio__label,.login .el-checkbox__label{
    font-size: 16px;
  }
  .login .el-checkbox__inner{
    width: 16px;
    height: 16px;
  }
  .login .el-checkbox__inner::after{
    left: 5px;
    top: 2px;
  }
</style>